import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { RoleSecurityService } from '../../authorization/role-security.service';
import { IDockingContext } from '../../../../model/docking';
import { DockingService } from '../docking.service';
import { EnvService } from '../../configuration/env.service';
import { BasicComponent } from '../../basic-component';

@Component({
    selector: 'app-docking-camera',
    templateUrl: './docking-camera.component.html',
    styleUrls: ['./docking-camera.component.scss']
})
export class DockingCameraComponent extends BasicComponent implements OnInit, OnChanges {
    @Input() dockingContext: IDockingContext;
    showCamera = false;
    videoStreamAvailable = false;
    userHasAccess = false;

    constructor(
        private readonly dockingService: DockingService,
        private readonly roleSecurityService: RoleSecurityService,
        private readonly env: EnvService
    ) {
        super();
    }

    ngOnInit(): void {
        this.showCamera = this.env.config.camera.show;
        this.userHasAccess = this.roleSecurityService.userCanView('cameras');
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.dockingContext?.currentValue) {
            this.videoStreamAvailable = this.dockingContext.cameraURL && this.dockingContext.cameraURL !== '';
        }
    }

    getCameraFeedUrl() {
        return `http://${this.dockingContext?.cameraURL}/mjpg/video.mjpg`;
    }
}
